export default "__VITE_ASSET__CeT8LE3X__";